<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="workDocsSchemeClassGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
      >
        <template v-slot:buttons>
          <WorkDocsSchemeClassModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_scheme_classes',
              })
            "
            :create="true"
          />
        </template>
        <WorkDocsSchemeClassTable :items="workDocsSchemeClassGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import WorkDocsSchemeClassTable from 'components/setting/workDocsSchemeClass/WorkDocsSchemeClassTable'
import WorkDocsSchemeClassModal from 'components/setting/workDocsSchemeClass/WorkDocsSchemeClassModal'

export default {
  name: 'WorkDocsSchemeClass',
  components: {
    TemplateView,
    TemplatePageGrid,
    WorkDocsSchemeClassTable,
    WorkDocsSchemeClassModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workDocsSchemeClass', ['workDocsSchemeClassGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workDocsSchemeClass', ['onWorkDocsSchemeClassGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkDocsSchemeClassGrid(data)
    },
  },
}
</script>
